import AppConfig from '../config';
import axios from 'axios';
import authApi from './auth';

// Synevo WP Shop API Docs:
// https://documenter.getpostman.com/view/222346/SzKQy19u

var api = {};

api.post = (url, data) => {
    return api.sendRequest("POST", url, data);
};

api.put = (url, data) => {
    return api.sendRequest("PUT", url, data);
};

api.delete = (url, data) => {
    return api.sendRequest("DELETE", url, data);
};
// API request get shorthand
api.get = (url, data) => {
    return api.sendRequest("GET", url, data);
};


api.sendRequest = (method, url, data) => {
    if(authApi.auth.logged){
        authApi.accessToken = authApi.auth.token.accessToken;
        if(Math.floor(Date.now() / 1000) > authApi.auth.token.expiresAt){
            authApi.logout().then(()=>{
                window.location.href='/login'
            })
            
            return new Promise(() => {});
        }
    }
    if (typeof headers == "undefined") var headers = {};
    let defaultHeaders = {
        'Content-Type': 'application/json',
    };
    headers = {...defaultHeaders, ...headers};
    if(authApi.accessToken){
        headers['Authorization'] = 'Bearer '+authApi.accessToken;
    }
    url = AppConfig.api.baseUrl + url;
    let options = {
        method: method,
        url: url,
        headers: headers,
    };
    if (method.toUpperCase() == 'GET') {
        options.params = data;
    } else {
        options.data = data;
    }
    return new Promise((resolve, reject) => {
        axios(options)
        .then((response) => { resolve(response); })
        .catch((response) => { reject(response); });
    });
};

export default api;
